export default "__VITE_ASSET__BMY1jy91__"